import React from 'react';
import { Select } from 'antd';
import { fetchWarehouseShipmentGroupShippingAccountList } from 'services/shipmentContainers';

type Props = {
  onChange?: Function;
  shipmentGroupNum: number;
  warehouseNum: number;
};

const ShippingAccountSelector = (props: Props) => {
  const { useState } = React;
  const [inited, setInited] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState<StringKAnyVPair[]>([]);
  //const [selectedShipAccount, setSelectedShipAccount] = useState<StringKAnyVPair>({});

  // eslint-disable-next-line
  const loadShippingAccounts = async () => {
    setIsLoading(true);
    try {
      const accounts = await fetchWarehouseShipmentGroupShippingAccountList(props.warehouseNum, props.shipmentGroupNum);
      accounts && setOptions(accounts.map((e: any) => ({ ...e, label: e.name, value: e.shipAccountNum })));
    } catch(e) {
    } finally {
      setIsLoading(false);
    }
  };

  const onShippingAccountChange = (shipAccountNum: number) => {
    const opt = options.find((e: any) => e.shipAccountNum === shipAccountNum);

    /*if (opt) {
      setSelectedShipAccount(opt);
    }*/
    props.onChange && props.onChange(opt);
  };

  React.useEffect(() => {
    if (!inited) {
      loadShippingAccounts();
      setInited(true);
    }
  }, [inited, loadShippingAccounts]);

  return (<>
    <Select
      allowClear
      loading={isLoading}
      onChange={onShippingAccountChange}
      options={options}
      style={{ width: '100%' }}
    />
  </>);
};

export default ShippingAccountSelector;
